module.exports = __webpack_public_path__ + "media/images/icons/flags/TO-1fe8cbe897e1308b4d535aef96f1b5bd.svg";